export default "__VITE_ASSET____PDQak0__"